module.exports = __webpack_public_path__ + "media/images/svg/hush-logo-14d54308b3ba765ae0df4133628ba91a.svg";